import React, { useContext, useEffect } from 'react'
import Dashboard from './pages/Dashboard'
import { Navigate, Route, Routes } from 'react-router-dom'
import styled, { ThemeProvider } from 'styled-components'
import Login from './pages/Login'
import Product from './pages/Product'
import Profile from './pages/Profile'
import City from './pages/City'
import States from './pages/States'
import Area from './pages/Area'
import User from './pages/User'
import Customer from './pages/Customer'
import DeliveryBoy from './pages/DeliveryBoy'
import StockHistory from './pages/StockHistory'
import Permissions from './pages/Permissions'
import Orders from './pages/Orders'
import SubOrders from './pages/SubOrders'
import DeliveryPartner from './pages/DeliveryPartner'
import { MyContext } from './context/Context'
import PaymentHistory from './pages/PaymentHistory'
import DataTable from './pages/DataTable'
import FailedOrders from './pages/FailedOrders'
import TermsAndConditions from './pages/TermsAndConditions'
import PrivacyPolicy from './pages/PrivacyPolicy'
import RequestForDietician from './pages/RequestForDietician'
// import DataTable from 'datatables.net-dt'

const theme = {
  colors: {
    sidebar_text: "#333032",
    bg: "#606060",
    green: "#61903F",
    white: "white",
    black: "black",
  }
};

function App() {
  const { userType } = useContext(MyContext);

  return (
    <ThemeProvider theme={theme}>

      <Routes>
        <Route path='/profile' element={<> <Profile /> </>} />
        <Route path='/' element={<> <Login /> </>} />
        {
          userType !== 'delivery_boy' && (
            <>
              <Route path='/dashboard' element={<> <Dashboard /> </>} />
              
              <Route path='/product' element={<> <Product /> </>} />

              <Route path='/stock-history' element={<> <StockHistory /> </>} />

              <Route path='/state' element={<> <States /> </>} />
              <Route path='/city' element={<> <City /> </>} />
              <Route path='/area' element={<> <Area /> </>} />
              
              <Route path='/user' element={<> <User /> </>} />
              <Route path='/customer' element={<> <Customer /> </>} />
              <Route path='/delivery-boy' element={<> <DeliveryBoy /> </>} />
              <Route path='/permissions' element={<> <Permissions /> </>} />

              
              <Route path='/orders' element={<> <Orders /> </>} />
              <Route path='/sub-orders' element={<> <SubOrders /> </>} />
              <Route path='/failed-orders' element={<> <FailedOrders /> </>} />

              <Route path='/payment-history' element={<> <PaymentHistory /> </>} />
              <Route path='/request-for-dietician' element={<> <RequestForDietician /> </>} />
              <Route path='/terms-and-conditions' element={<> <TermsAndConditions /> </>} />
              <Route path='/privacy-policy' element={<> <PrivacyPolicy /> </>} />
              <Route path='/table' element={<> <DataTable /> </>} />
            </>
          )
        }

        {userType === 'delivery_boy' && (<Route path="/delivery-partner" element={<DeliveryPartner />} />)}
        {userType === 'delivery_boy' && (<Route path="*" element={<Navigate to="/delivery-partner" />} />)}
        
      </Routes>

    </ThemeProvider>
  )
}

export default App




